import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { UploaderSelect } from "~/components/Selects/Uploader/UploaderSelect";
export const mapUploaderFilterToOption = (uploader)=>({
        ...uploader,
        id: uploader.value
    });
export const mapOptionToUploaderFilter = (uploader)=>({
        ...uploader,
        value: uploader.id
    });
export const UploaderFilter = /*#__PURE__*/ memo((param)=>{
    let { onUploaderSelectionChange, uploadersOptions, selectedOptions } = param;
    return /*#__PURE__*/ _jsx(UploaderSelect, {
        hasDropdownOverlay: true,
        size: "large",
        uploaders: uploadersOptions,
        selectedUploaders: selectedOptions,
        onUploaderSelectionChange: onUploaderSelectionChange
    });
});
UploaderFilter.displayName = "UploaderFilter";
